import { render, staticRenderFns } from "./profile_header.vue?vue&type=template&id=28a9e502&"
import script from "./profile_header.vue?vue&type=script&lang=js&"
export * from "./profile_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports